import { Link, useLocation } from 'react-router-dom';
import { ClipboardCheck, MapPin, ChartNoAxesCombined, Printer } from 'lucide-react';
import './packTools.css';

export const PackToolShell = ({ title, children }) => {
  const { pathname } = useLocation();
  const mobile = pathname.startsWith('/staff-app');
  const base = mobile ? '/staff-app/tools/' : '/inventory/';
  return <div className={`pack-tools ${mobile ? 'p-4' : ''}`} data-testid="pack-tool-page">
    <h1 data-testid="pack-tool-heading">{title}</h1>
    <nav className="pack-tools-nav" aria-label="Stock tools" data-testid="pack-tool-nav">
      {[['pack-counts', 'Pack counts', ClipboardCheck], ['shelf-moves', 'Shelf moves', MapPin], ['stock-insights', 'Stock insights', ChartNoAxesCombined], ['printer-profiles', 'Label profiles', Printer]].map(([path, name, Icon]) => <Link key={path} to={base+path} className={pathname.endsWith(path) ? 'active' : ''} data-testid={`pack-nav-${path}`}><Icon size={16}/>{name}</Link>)}
    </nav>{children}
  </div>;
};

export const PackError = ({ error }) => error ? <p role="alert" className="pack-error" data-testid="pack-tools-error">{error}</p> : null;
export const message = e => typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Could not complete this action. Please check the values and try again.';
export const savePdf = (blob, filename) => { const url = URL.createObjectURL(blob); const a = document.createElement('a'); a.href = url; a.download = filename; a.click(); setTimeout(() => URL.revokeObjectURL(url), 60000); };